export default {
  /**
  * 绑定方法
  * @param {Object} el - The element the directive is bound to.
  * @param {Object} binding - An vue directive object
  */
  bind: function bind(el, binding) {
    var immediate = binding.modifiers.immediate;

    var documentHandler = function documentHandler(e) {
      // 立即监听
      if (immediate) {
        if (el.contains(e.target)) {
          return;
        }

        binding.value(e);
        return;
      } // 非立即监听


      if (el.contains(e.target) || !el.__isfirst__) {
        el.__isfirst__ = true;
        return;
      }

      binding.value(e);
    };

    el.__vueClickOutside__ = documentHandler;
    document.addEventListener('click', documentHandler, false);
  },

  /**
  * 更新方法
  */
  update: function update() {},

  /**
  * 销毁方法
  * @param {Object} el - The element the directive is bound to.
  */
  unbind: function unbind(el) {
    document.removeEventListener('click', el.__vueClickOutside__);
    delete el.__vueClickOutside__;
  }
};